import { render, staticRenderFns } from "./campaignGeneralFields.vue?vue&type=template&id=17a5aa32&"
import script from "./campaignGeneralFields.vue?vue&type=script&lang=js&"
export * from "./campaignGeneralFields.vue?vue&type=script&lang=js&"
import style0 from "./campaignGeneralFields.vue?vue&type=style&index=0&id=17a5aa32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports